export function initializeResultsHeadingBehaviour() {
    // Behaviour for the results heading on the results pages. This will expand and shrink the search form results container based on the scroll direction.
    const THRESHOLD_UP = 25;
    const THRESHOLD_DOWN = 10;

    const pagesWithHeadingBehavior = [
        'results.region',
        'results.map',
        'results.attraction',
        'results.favourites',
        'results.favourites.list'
    ];

    // Check if current page should have heading behavior
    const shouldHaveHeadingBehavior = () => {
        // First check the explicit list
        if (pagesWithHeadingBehavior.includes(window.tg.page_name)) {
            return true;
        }

        // Fallback: any results.* page with the search form element
        if (window.tg.page_name?.startsWith('results.') && document.getElementById('search-form-results')) {
            return true;
        }

        return false;
    };

    // Apply heading behavior if conditions are met
    if (shouldHaveHeadingBehavior() && window.tg.site === 'ls') {
        const searchFormResults = document.getElementById('search-form-results');

        if (!searchFormResults) return;

        let lastScrollTop = 0;

        // Attach scroll event listener
        window.addEventListener('scroll', () => {
            const generalStore = typeof Alpine !== 'undefined' ? Alpine.store('general') : null;
            const isSearchSectionOpen = generalStore?.openSection === 'SEARCH';
            const isNoSectionOpen = generalStore?.openSection === 'NONE';

            if (isSearchSectionOpen && window.tg.is_mobile_device) {
                searchFormResults.classList.add('expand');
                searchFormResults.classList.remove('shrink');
            }

            if (!isNoSectionOpen) return;

            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollDistance = Math.abs(currentScrollTop - lastScrollTop);

            if (currentScrollTop === 0) {
                searchFormResults.classList.add('expand');
                searchFormResults.classList.remove('shrink');
            } else if (currentScrollTop > lastScrollTop && scrollDistance > THRESHOLD_DOWN) {
                searchFormResults.classList.remove('expand');
                searchFormResults.classList.add('shrink');
            } else if (scrollDistance > THRESHOLD_UP) {
                searchFormResults.classList.add('expand');
                searchFormResults.classList.remove('shrink');
            }

            lastScrollTop = Math.max(currentScrollTop, 0);
        });
    }

    // Set header spacer height to match header height dynamically
    // Apply to all non-homepage pages on 'ls' site
    if (window.tg.page_key !== 'homepage' && window.tg.site === 'ls') {
        const headerSpacer = document.querySelector('.results-view-header-spacer');
        const header = document.querySelector('#js-header');

        function updateHeaderSpacerHeight() {
            if (!headerSpacer || !header) return;

            let baseHeight = header.getBoundingClientRect().height;

            if (window.tg.is_app) {
                const computedStyle = getComputedStyle(header);
                const paddingTop = parseFloat(computedStyle.getPropertyValue('padding-top'));
                baseHeight -= paddingTop;
            }

            headerSpacer.style.height = `${baseHeight}px`;
        }

        updateHeaderSpacerHeight();

        // Add event listener for window resize
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(updateHeaderSpacerHeight, 100);
        });
    }
}

initializeResultsHeadingBehaviour();
